'use client';
import React from 'react';
import Link from 'next/link';

export default function CtaBlock() {
  return (
    <div
      className="my-6 relative overflow-hidden"
      style={{
        background: 'linear-gradient(135deg, #0d0d2b 0%, #111130 100%)',
        border: '1px solid rgba(0,245,255,0.25)',
        padding: 'clamp(32px, 5vw, 56px) clamp(20px, 4vw, 48px)',
        boxShadow: '0 0 40px rgba(0,245,255,0.08)',
      }}
    >
      {/* Cyan accent stripe */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '4px',
          height: '100%',
          background: 'linear-gradient(180deg, #00f5ff, #7b2fff)',
          boxShadow: '0 0 12px rgba(0,245,255,0.5)',
        }}
      />
      {/* Corner accent */}
      <div style={{ position: 'absolute', top: 0, right: 0, width: '80px', height: '80px', background: 'radial-gradient(circle at top right, rgba(255,0,255,0.1) 0%, transparent 70%)', pointerEvents: 'none' }} />

      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 pl-4">
        <div>
          <div
            className="inline-block px-3 py-1 mb-3"
            style={{ background: 'rgba(255,0,255,0.08)', border: '1px solid rgba(255,0,255,0.3)' }}
          >
            <span
              style={{
                fontFamily: 'Barlow Condensed, Arial, sans-serif',
                fontWeight: 900,
                fontSize: '11px',
                textTransform: 'uppercase',
                letterSpacing: '0.12em',
                color: '#ff00ff',
              }}
            >
              Launching Sept–Oct 2026
            </span>
          </div>
          <h3
            style={{
              fontFamily: 'Barlow Condensed, Arial, sans-serif',
              fontWeight: 900,
              fontSize: 'clamp(24px, 4vw, 40px)',
              textTransform: 'uppercase',
              color: '#e0e8ff',
              lineHeight: 1.05,
              letterSpacing: '0.01em',
              marginBottom: '8px',
            }}
          >
            Register Early.
            <br />
            <span style={{ color: '#00f5ff', textShadow: '0 0 16px rgba(0,245,255,0.5)' }}>Lock In 15% Off.</span>
          </h3>
          <p style={{ fontSize: '14px', color: '#a0b0d8', fontWeight: 400, maxWidth: '480px' }}>
            Join the waitlist or send us your vehicle photos for a custom quote — we'll reach out before launch.
            Questions?{' '}
            <a
              href="https://www.instagram.com/vertexpremiummobiledetailing"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#ff00ff', fontWeight: 700, textShadow: '0 0 8px rgba(255,0,255,0.4)' }}
            >
              DM us on Instagram
            </a>.
          </p>
        </div>
        <div className="flex flex-col sm:flex-row md:flex-col gap-3 shrink-0 w-full md:w-auto">
          <Link
            href="/waitlist"
            className="z-btn-yellow flex items-center justify-center gap-2"
            style={{ minHeight: '52px', fontSize: '14px', padding: '14px 32px', whiteSpace: 'nowrap', textDecoration: 'none' }}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
              <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
            Join Waitlist
          </Link>
          <a
            href="/home#quote"
            className="flex items-center justify-center gap-2"
            style={{
              fontFamily: 'Barlow Condensed, Arial, sans-serif',
              fontWeight: 900,
              fontSize: '14px',
              textTransform: 'uppercase',
              letterSpacing: '0.1em',
              color: '#00f5ff',
              border: '1px solid rgba(0,245,255,0.4)',
              padding: '14px 32px',
              textDecoration: 'none',
              minHeight: '52px',
              background: 'rgba(0,245,255,0.05)',
              whiteSpace: 'nowrap',
            }}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
            </svg>
            Get a Quote
          </a>
        </div>
      </div>
    </div>
  );
}